import echarts from 'echarts/lib/echarts';
import zrUtil from 'zrender/lib/core/util';

import("./FunnelSeries");
import("./FunnelView");
import dataColor from 'echarts/lib/visual/dataColor';
import funnelLayout from './funnelLayout';
import dataFilter from 'echarts/lib/processor/dataFilter';
echarts.registerVisual(zrUtil.curry(dataColor, 'funnelAlign'));
echarts.registerLayout(funnelLayout);
echarts.registerProcessor(zrUtil.curry(dataFilter, 'funnelAlign'));


// WEBPACK FOOTER //
// ./src/components/ui/funnel/funnel.js